import {
  CheckCircleOutlined,
  CodeSandboxOutlined,
  SlidersOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH, MANAGER_PREFIX_PATH } from "configs/AppConfig";

const dashBoardNavTree = [
  {
    key: "home",
    path: `${MANAGER_PREFIX_PATH}/approval-pinjaman`,
    title: "Approval Pinjaman",
    icon: CheckCircleOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "riwayat-pencairan",
    path: `${MANAGER_PREFIX_PATH}/riwayat-pencairan`,
    title: "Riwayat Pencairan",
    icon: HistoryOutlined,
    breadcrumb: false,
    submenu: [],
  },
  // {
  //   key: "pinjaman-barang",
  //   path: `${MANAGER_PREFIX_PATH}/pinjaman-barang`,
  //   title: "Pinjaman Barang",
  //   icon: CodeSandboxOutlined,
  //   breadcrumb: false,
  //   submenu: [],
  // },
  // {
  //   key: "pinjaman-stnk",
  //   path: `${MANAGER_PREFIX_PATH}/pinjaman-stnk`,
  //   title: "Pinjaman STNK",
  //   icon: FileTextOutlined,
  //   breadcrumb: false,
  //   submenu: [],
  // },
  {
    key: "pelunasan",
    path: `${MANAGER_PREFIX_PATH}/pelunasan`,
    title: "Pemutihan",
    icon: CodeSandboxOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const name = localStorage.getItem("name");

if (name) {
  if (name.search("HQ") > 0) {
    dashBoardNavTree.push(
      {
        key: "pelunasan",
        path: `${MANAGER_PREFIX_PATH}/pelunasan`,
        title: "Pelunasan",
        icon: CodeSandboxOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "pengaturan-budget",
        path: `${MANAGER_PREFIX_PATH}/pengaturan-budget`,
        title: "Pengaturan Budget",
        icon: SlidersOutlined,
        breadcrumb: false,
        submenu: [],
      },
    );
  }
}

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
